import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class NewThemeViewsService {

constructor() {}


newViewsUrl(): string[] {
    const newLayoutPageUrls: string[] = [
        'home',
        'create-shifts',
        'shift-requests',
        'ongoing-shifts',
        'previous-shifts'
    ];
    return newLayoutPageUrls;
}

    
  newHeaderProperties(currentView: string, extendedParams?: string) {
    const currentHeaderProperties = {
        'home': {
          'heading': 'Home',
          'button': 'Create shift',
          'navigateTo': 'company-dashboard/create-shifts'
        }, 
    
        'create-shifts': {
          'heading': 'Create Shift',
          'button': null,
          'navigateTo': null
        },

        'previous-shifts': {
          'heading': 'Previous Shifts',
          'button': null,
          'navigateTo': null,
          'icon': 'fa fa-calendar',
          "toggleBar": {
              data : {
                allText: 'All',
                leftText : 'Regular',
                rightText : 'Recurring'
              }
          }
        },
        
        'shift-requests': {
          'unfilled': {
            'heading': 'Unfilled Requests',
            'button': null,
            'navigateTo': null,
            'icon': 'fa fa-calendar',
            "toggleBar": {
                data : {
                    allText : 'All',
                    leftText: 'Regular',
                    rightText : 'Recurring'
                }
            }
          }, 
          'filled': {
            'heading': 'Filled Requests',
            'button': null,
            'navigateTo': null,
            'icon': 'fa fa-calendar',
            "toggleBar": {
                data : {
                  allText: 'All',
                  leftText : 'Regular',
                  rightText : 'Recurring'
                }
            }
          },
          'ongoing-shifts': {
            'heading': 'Ongoing Shifts',
            'button': null,
            'navigateTo': null,
            'icon': null
          },
        },
        'multi-shift-builder': {
          'heading': 'Shift Loader Pro',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'other-addresses': {
          'heading': 'Addresses',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'pay-unpaid-invoices': {
          'heading': 'Invoices',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'invoice-file-dispute': {
          'heading': 'File dispute',
          'button': null,
          'navigateTo': null,
          'icon': null,
          [extendedParams]: {
            'heading': 'File dispute',
            'button': null,
            'navigateTo': null,
            'icon': null
          }
        },
        'full-calendar': {
          'heading': 'Shifts Calendar',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'business-profile-edit': {
          'heading': 'Edit Company Profile',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'edit-password': {
          'heading': 'Update Password',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'edit-shift': {
          'heading': 'Edit Shift Details',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'previous-staffies': {
          'heading': 'Previous Hires',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'view-invoice': {
          'heading': 'Invoice Details',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'view-receipt': {
          'heading': 'Payment Details',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'wallet': {
          'heading': 'Credit Notes',
          'button': null,
          'navigateTo': null,
          'icon': null
        },
        'notification-preferences': {
          'heading': 'Notification Preference',
          'button': null,
          'navigateTo': null,
          'icon': null
        }
    };

    if(!currentView || !currentHeaderProperties[currentView]) {
        if (!currentView) return { heading: '', button: null, navigateTo: null, icon: null };
        // If no matching view found, capitalize each word and replace hyphens with spaces
        const formattedHeading = currentView
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
        return {
            heading: formattedHeading,
            button: null,
            navigateTo: null,
            icon: null
        };
    }
    return extendedParams ? currentHeaderProperties[currentView][extendedParams] : currentHeaderProperties[currentView];
  }
}

